import baseRoute from '../baseRoute';

export default `${baseRoute}/authentication` as const;
